import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import CardColumn from "components/CardColumn";
import { Button, Icon } from "@alm/flow-ds/components";

export interface InfoBarColumn {
	prop: string;
	value: string | JSX.Element | undefined;
	width: "xs" | "sm" | "md" | "lg" | "xl" | "fill";
}

interface Props {
	data: InfoBarColumn[][];
	showButton?: boolean;
	stylesForRow?: string;
}

const InfoBar = ({ data, showButton = true, stylesForRow }: Props) => {
	const MOBILE_WIDTH = 768;

	const { t } = useTranslation();

	const [showMore, setShowMore] = useState(false);

	const [width, setWidth] = useState(window.innerWidth);

	const handleWindowSizeChange = () => setWidth(window.innerWidth);

	useEffect(() => {
		window.addEventListener("resize", handleWindowSizeChange);
		return () => {
			window.removeEventListener("resize", handleWindowSizeChange);
		};
	}, []);

	useEffect(() => {
		if (!showButton) setShowMore(true);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const buttonLabel = (
		<span>
			<span className="detailed-view--button__toggle-details--text">
				{t(`main.tasks.labels.${showMore ? "showLess" : "showMore"}`)}
			</span>
			<Icon type={`angle-${showMore ? "up" : "down"}`} />
		</span>
	);

	const renderPropValuePair = ({ width, prop, value }: InfoBarColumn) => (
		<CardColumn
			className="detailed-view__info-row-item"
			width={width}
			key={prop}>
			<div className="detailed-view__info-row-item--prop">{prop}</div>
			<div className="detailed-view__info-row-item--value">
				{value || (prop ? t("main.text.na") : "")}
			</div>
		</CardColumn>
	);

	return (
		<>
			<div className="detailed-view">
				<div className="detailed-view__info">
					{showMore || width >= MOBILE_WIDTH ? (
						data.map((row, index) => {
							return (
								<div
									className={`detailed-view__info-row ${stylesForRow}`}
									key={index.toString()}>
									{row.map(property =>
										renderPropValuePair(property)
									)}
								</div>
							);
						})
					) : (
						<div
							className="detailed-view__info-row"
							key={data[0].toString()}>
							{data[0].map(property =>
								renderPropValuePair(property)
							)}
						</div>
					)}
				</div>
			</div>
			{showButton && (
				<Button
					label={buttonLabel}
					onClick={() => setShowMore(!showMore)}
					className="detailed-view--button__toggle-details"
				/>
			)}
		</>
	);
};

export default InfoBar;
